/**
 * Browser implementation of the device store. Every call is guarded: Safari in
 * private mode throws on access rather than returning null.
 */
function safeLocalStorage(): Storage | null {
  try {
    if (typeof localStorage === 'undefined') return null;
    return localStorage;
  } catch {
    return null;
  }
}

export const deviceStorage = {
  async getItem(key: string): Promise<string | null> {
    try {
      return safeLocalStorage()?.getItem(key) ?? null;
    } catch {
      return null;
    }
  },
  async setItem(key: string, value: string): Promise<void> {
    try {
      safeLocalStorage()?.setItem(key, value);
    } catch {
      /* quota or private mode — keep running from memory */
    }
  },
  async removeItem(key: string): Promise<void> {
    try {
      safeLocalStorage()?.removeItem(key);
    } catch {
      /* ignore */
    }
  },
};
